export default {
  downloadData(data, title, suffix) {
    if (!data) {
      return;
    }
    const blob = new Blob([data]);
    const url = window.URL.createObjectURL(blob);
    const aLink = document.createElement('a');
    if ('download' in document.createElement('a')) {
      aLink.style.display = 'none';
      aLink.href = url;
      aLink.setAttribute('download', `${title}.${suffix || 'xlsx'}`);
      document.body.appendChild(aLink);
      aLink.click();
      document.body.removeChild(aLink);
      window.URL.revokeObjectURL(url);
    } else {
      navigator.msSaveBlob(blob, `${title}.${suffix || 'xlsx'}`);
    }
  }
};
